import useFeature from '@/contexts/FeatureFlags/useFeature';
import useFundAccess from '@/hooks/useFundAccess';

/**
 * The one key that governs "מרכז ההתכתבויות" — both directions of it. Must match
 * FeatureFlagKeys.Inquiries on the server and the row seeded by
 * SeedFeatureFlag_Inquiries.sql.
 */
export const INQUIRIES_FEATURE_KEY = 'inquiries';

/**
 * Whether the inquiries feature is on for the current user.
 *
 * Every entry point into inquiries asks this one hook rather than reading the flag itself, so
 * the feature cannot come back half-on: the screens, the open-inquiry button on a row, the
 * header capsule, the sidebar items and the chimes all appear and disappear together.
 *
 * Off is the safe answer and the one that is given whenever anything is missing — the flag row,
 * the ruleset, the provider — because an inquiry that can be opened but not answered is the
 * fault this flag exists to prevent.
 *
 * Inquiries belong to «שאר המערכת» among the permission worlds (Druk, 22.10.2026): a coordinator
 * that world is closed to gets the same answer as with the flag off, in the fund the address names.
 */
export default function useInquiriesFeature(): boolean {
  const isOn = useFeature(INQUIRIES_FEATURE_KEY);
  const { canView } = useFundAccess();
  return isOn && canView('Other');
}
